import axios from 'axios';

const setActiveCostCenters = (costCenters) => {
  return axios.post('/api/admin/setActiveCostCenters', { costCenters: costCenters });
};

const getNotUsedUserGroups = (config) => {
  return axios.get('/api/cost-centers/not-used', config);
};

const deleteUserGroups = (userGroup) => {
  return axios.delete('/api/cost-centers', {data: userGroup});
};

const addOrEditCostCenters = (costCenters) => {
  return axios.post('/api/cost-centers/addOrEdit', {costCenters: costCenters});
};

const getCostCenters = () => {
  return axios.get('/api/cost-centers');
};

const combineCostCenters = (mainCostCenterId, costCenterIds,newCostCenterName) => {
  return axios.post('/api/cost-centers/combineCostCenters', {mainCostCenterId, costCenterIds,newCostCenterName});
};

const getCostCentersForBudget = () => {
  return axios.get('/api/cost-centers/costCentersForBudget');
};

export {
  getNotUsedUserGroups,
  deleteUserGroups,
  setActiveCostCenters,
  addOrEditCostCenters,
  getCostCenters,
  combineCostCenters,
  getCostCentersForBudget
};
